var map = {
	"./account-ico-mail.svg": 814,
	"./account-ico-pass.svg": 815,
	"./account-ico-phone.svg": 816,
	"./bank-transfer.svg": 817,
	"./betnearn-ico.svg": 818,
	"./birthday-bonus-ico.svg": 819,
	"./birthday.webp": 1896,
	"./bonus-code-ico.svg": 820,
	"./bonus-ico.svg": 821,
	"./bonus-received-ico.svg": 822,
	"./bonus.webp": 1897,
	"./business-account-upgrade-ico.svg": 823,
	"./check-in-daily-ico.svg": 824,
	"./checked.svg": 825,
	"./cloud-pointer.svg": 826,
	"./crypto.svg": 827,
	"./daily-bonus-ico.svg": 828,
	"./daily-limit.webp": 1898,
	"./deposit-delay-bonus-ico.svg": 829,
	"./e-wallet.svg": 830,
	"./earn-coin-ico.svg": 831,
	"./earn-x33-coin-ico.svg": 832,
	"./email.svg": 833,
	"./facebook.svg": 834,
	"./feedback.svg": 835,
	"./first-bet-ico.svg": 836,
	"./games-rebate-ico.svg": 837,
	"./info.svg": 838,
	"./instagram.svg": 839,
	"./instant-rebate.svg": 840,
	"./live-casino-rebate-ico.svg": 841,
	"./lucky-spin-ico.svg": 842,
	"./messenger.svg": 843,
	"./mobile-app-deposit-ico.svg": 844,
	"./monthly-cash.webp": 1899,
	"./msg-activity.svg": 845,
	"./msg-ann.svg": 846,
	"./msg-notice.svg": 847,
	"./new-icon.svg": 848,
	"./people-ico.svg": 849,
	"./quick-pay.svg": 850,
	"./r77-coin.svg": 851,
	"./rescue-bonus-ico.svg": 852,
	"./rescue-lc-ico.svg": 853,
	"./rescue-slots-ico.svg": 854,
	"./return.svg": 855,
	"./sc-bc-active-ico.svg": 856,
	"./sc-bc-ico.svg": 857,
	"./sc-bi-active-ico.svg": 858,
	"./sc-bi-ico.svg": 859,
	"./sc-mail-active-ico.svg": 860,
	"./sc-mail-ico.svg": 861,
	"./sc-mp-active-ico.svg": 862,
	"./sc-mp-ico.svg": 863,
	"./sc-pin-active-ico.svg": 864,
	"./sc-pin-ico.svg": 865,
	"./slots-rebate-ico.svg": 866,
	"./sports-rebate-ico.svg": 867,
	"./telegram.svg": 868,
	"./twitter.svg": 869,
	"./vip-up-level-ico.svg": 870,
	"./vip-weekly-bonus.svg": 871,
	"./wallet-ico.svg": 872,
	"./weekly-tournament-ico.svg": 873,
	"./welcome-bonus-ico.svg": 874,
	"./whatsapp.svg": 875,
	"./withdrawal-delay-bonus-ico.svg": 876,
	"./withdrawal.webp": 1900,
	"./x33-coin.svg": 877
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 479;